/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "underscore",
  "jquery",
  "utils/lzma-url"
  ], function(
    _,
    $,
    Lzma
  ) {

    var urlParameters,
    _initURLParameters = function () {
      urlParameters = {};

      try {
        var parameters = location.search.substring(1).replace(/\+/g, ' ').split('&');

        _.each(parameters, function (parameter) {
            var name, value,
                splitParameter = parameter.split('=');

            name = splitParameter[0];
            if (splitParameter.length > 1) {
              try {
                value = decodeURIComponent(splitParameter[1]);
                urlParameters[name] = value;
              } catch (e) {}
            }

        });
      } catch (e) { }
    };

    function getURLParameterByString (name, url) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function getURLParametersByString (url) {
      var urlParameters = {};
      var parameters = url.split("?")[1] && url.split("?")[1].replace(/\+/g, ' ').split('&');

      _.each(parameters, function (parameter) {
        var name, value,
        splitParameter = parameter.split('=');

        name = splitParameter[0];
        if (splitParameter.length > 1) {
          try {
            value = decodeURIComponent(splitParameter[1]);
            urlParameters[name] = value;
          } catch (e) {}
        }

      });

      return urlParameters; 
    }

    function replaceUrlParam(url, paramName, paramValue){
      if(paramValue == null || paramValue == "")
          return url
          .replace(new RegExp('[?&]' + paramValue + '=[^&#]*(#.*)?$'), '$1')
          .replace(new RegExp('([?&])' + paramValue + '=[^&]*&'), '$1');   
      url = url.replace(/\?$/,'');
      var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)')
      if(url.search(pattern)>=0){
          return url.replace(pattern,'$1' + paramValue + '$2');
      }
      return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue 
    }

    function getBrowserName() {
      // Opera 8.0+
      var opr = opr;
      var isOpera = (!!window.opr && opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';
      // Safari 3.0+ "[object HTMLElementConstructor]" 
      var safari = safari || false;
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (safari && safari.pushNotification));
      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;
      // Chrome 1+
      var isChrome = !!window.chrome && !!window.chrome.webstore;
      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;

      if (isOpera) return "Opera";
      else if (isFirefox) return "Firefox";
      else if (isSafari) return "Safari";
      else if (isIE) return "IE";
      else if (isEdge) return "Edge";
      else if (isChrome) return "Chrome";
      else if (isBlink) return "Blink";
      else return null;
    }

    function isOutlook() {
      var agent = window.navigator.userAgent;
      var isOutlook = agent.includes("Microsoft") && agent.includes("Outlook");

      return isOutlook;
    }

    function isIosApp() {
        if (typeof window === undefined) { return false };
    
        let navigator = window.navigator;
    
        const standalone = navigator.standalone;
        const userAgent = navigator.userAgent.toLowerCase();
        const safari = /safari/.test(userAgent);
        const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
        const ios_ipad_webview = ios && !safari;
    
        return ios ? ( (!standalone && !safari) || ios_ipad_webview ) : userAgent.includes('wv');
    }

    function deparam(queryString) {
      var decodedString = decodeURIComponent(queryString);
      var params = decodedString.split('&');
      var paramObject = {};
    
      params.forEach(function(param) {
        var parts = param.split('=');
        var key = parts[0];
        var value = parts[1];
        var keys = key.replace(/\]/g, '').split('[');
        var current = paramObject;
    
        keys.forEach(function(key, index) {
          var isLastKey = index === keys.length - 1;
          var isNumericKey = /^\d+$/.test(key); // Checks if the key is purely numeric
          var isYearLikeString = /^[12]\d{3}(\.\w+)?$/.test(key); // Checks if the key is a year-like string with possible suffix
          var nextKeyIsNumeric = /^\d+$/.test(keys[index + 1]);
    
          if (isLastKey) {
            if (Array.isArray(current)) {
              current.push(decodeURIComponent(value));
            } else if (nextKeyIsNumeric && !isYearLikeString) {
              if (!current[key]) current[key] = [];
              current[key].push(decodeURIComponent(value));
            } else {
              current[key] = decodeURIComponent(value);
            }
          } else {
            if (!current[key]) {
              if (nextKeyIsNumeric && !isYearLikeString) {
                current[key] = [];
              } else {
                current[key] = {};
              }
            }

            current = current[key];
          }
        });
      });
    
      // Post-process to handle any potential arrays that were incorrectly created
      function cleanUpArrays(obj) {
        if (Array.isArray(obj)) {
          if (Object.keys(obj).every(function(k) { return k.match(/^\d+$/); })) {
            return obj.map(cleanUpArrays);
          } else {
            // Convert back to object if array was incorrectly created
            return Object.assign({}, obj);
          }
        } else if (typeof obj === 'object') {
          for (var key in obj) {
            obj[key] = cleanUpArrays(obj[key]);
          }
        }
        return obj;
      }
    
      return cleanUpArrays(paramObject);
    }

    function createEncodedRequestURL(options, selectedTabName, constraints) {
      var request = { "r": options };
      if (selectedTabName) {
        request.r.selectedTabName = selectedTabName;
      }

      // Encode the request object
      var encodedRequest = encodeURIComponent($.param(request));
      // Return the encoded request and filters
      return {
        encodedRequest: Lzma.compressUrlSafe(encodedRequest),

      };
    }

    var browser = {
      getURLParameter: function (name, force) {
        return this.getURLParameters(force)[name];
      },

      isOutlook: function () {
        return isOutlook();
      },

      isIosApp: function () {
        return isIosApp();
      },

      getURLParameters: function(force) {
        if (force || typeof urlParameters === 'undefined') {
          _initURLParameters();
        }
        return urlParameters; 
      },

      getURLParameterByString: function (parameter, strURL) {
        return getURLParameterByString(parameter, strURL);
      },

      createEncodedRequestURL: function(options, selectedTabName, constraints) {
        return createEncodedRequestURL(options, selectedTabName, constraints)
      },

      deparam: function(queryString) {
        return deparam(queryString)
      },

      getURLParametersByString: function (strURL) {
        return getURLParametersByString(strURL);
      },

      replaceUrlParam: function (url, paramName, paramValue){
        return replaceUrlParam(url, paramName, paramValue);
      },

      getURL: function () {
        var window = this.getWindow();
        return window && window.location.href;
      },

      getScheme: function () {
        var window = this.getWindow();
        return window && window.location.protocol;
      },

      getHostname: function () {
        var window = this.getWindow();
        return window && window.location.host;
      },

      getPort: function () {
        var window = this.getWindow();
        return window && window.location.port;
      },

      getPathname: function () {
        var window = this.getWindow();
        return window && window.location.pathname;
      },

      getHashValue: function () {
        var window = this.getWindow();
        return window && window.location.hash;
      },

      getWindow: function () {
        if (typeof window === "undefined") return;
        return window;
      },

      hasIEVendorPrefix: function () {
        return ("msTransition" in document.createElement("div").style);
      },

      isTouchDevice: function () {
        var el = document.createElement('div');
        el.setAttribute('ontouchstart', 'return;');

        if (typeof el.ontouchstart == "function"){
          return true;
        } else {
          return false
        }
      },

      isMobileSafari: function () {
        return / Mobile\//.test(navigator.userAgent) && / Safari\//.test(navigator.userAgent);
      },

      isIE: function() {
        return getBrowserName() === "IE";
      },

      localStorageAvailable: function () {
        var key = "localStorageAvailable" + new Date().getTime();
        try {
          localStorage[key] = "true";
          localStorage.removeItem(key);
          return true;
        } catch (e) {
          return false;
        }
      },

      loadCSS: function (url, id) {
         var el = document.getElementById(id);
         if (!el) {
           el = document.createElement("link");
           el.rel = "stylesheet";
           el.href = url;
           el.id = id;
           (document.head || document.getElementsByTagName("script")[0].parentNode).appendChild(el);
         }
      },

      getBrowserName: function () {
        return getBrowserName();
      },

      updateURLByParameter: function (parameter, value, url) {
        var url = url || window.location.href;
        return replaceUrlParam(url, parameter, value);
      },

      isMobileWitdth: function () {
        return window.innerWidth <= 767;
      }

    };

    browser.isMobileSafariPrivateMode = function () {
        return browser.isMobileSafari() && !browser.localStorageAvailable();
    };

    return browser;

});
